import { inject, Pipe, PipeTransform } from '@angular/core';
import { ISystemDetails } from '../../models/common.models';
import { I18nService } from '../../services';
import { IPurchaseActivitySystemDetails } from '../../features/purchase-activity/data/purchase-activity.models';
import { IRfQSystemDetails } from '../../models/rfq.models';

type DetailsUnion = ISystemDetails | IPurchaseActivitySystemDetails | IRfQSystemDetails;

@Pipe({
  name: 'selectedSystem',
  standalone: false,
})
export class SelectedSystemPipe implements PipeTransform {
  private nameNa: string = '';
  private readonly i18nService: I18nService = inject(I18nService);

  constructor() {
    this.i18nService.getTranslationByKey('system-details.selected-system-name-na')
      .subscribe((translation) => {
        this.nameNa = translation;
      });
  }

  static generateSelectedSystem(siemensEquipmentId: string, name: string): string {
    return !siemensEquipmentId ? '-' : `${name} (${siemensEquipmentId})`;
  }

  // TODO: After all shops are harmonized, remove ISystemDetails and use only IPurchaseActivitySystemDetails.

  private isISystemDetails(details: DetailsUnion): details is ISystemDetails {
    return 'siemensEquipmentId' in details && 'nameEnUs' in details;
  }

  private isIPurchaseActivitySystemDetails(details: DetailsUnion): details is IPurchaseActivitySystemDetails {
    return 'equipmentId' in details && 'equipmentName' in details;
  }

  transform(systemDetails: DetailsUnion): string {
    if (!systemDetails) {
      return '';
    }

    let id: string;
    let name: string;

    if (this.isISystemDetails(systemDetails)) {
      id = systemDetails.siemensEquipmentId;
      name = systemDetails.nameEnUs || this.nameNa;
    } else if (this.isIPurchaseActivitySystemDetails(systemDetails)) {
      id = systemDetails.equipmentId;
      name = systemDetails.equipmentName || this.nameNa;
    } else {
      id = '';
      name = this.nameNa;
    }

    return SelectedSystemPipe.generateSelectedSystem(id, name);
  }
}
